// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Relude_Option = require("relude/src/Relude_Option.bs.js");
var CommonTypes_PhoneNumber = require("./CommonTypes_PhoneNumber.bs.js");
var CommonTypes_LongPhoneNumber = require("./CommonTypes_LongPhoneNumber.bs.js");

var Raw = {};

function parse(value) {
  return {
          name: value.name,
          phoneNumber: CommonTypes_PhoneNumber.GraphQL_API.parse(value.phoneNumber)
        };
}

function serialize(value) {
  var value$1 = value.phoneNumber;
  var value$2 = CommonTypes_PhoneNumber.GraphQL_API.serialize(value$1);
  var value$3 = value.name;
  return {
          name: value$3,
          phoneNumber: value$2
        };
}

function verifyArgsAndParse(_CommonTypes_Shift_OnsiteManager, value) {
  return parse(value);
}

function verifyName(param) {
  
}

function tToR(param) {
  var name = param.name;
  return Relude_Option.map((function (phoneNumber) {
                return {
                        name: name,
                        phoneNumber: phoneNumber
                      };
              }), CommonTypes_LongPhoneNumber.fromString(CommonTypes_PhoneNumber.toString(param.phoneNumber)));
}

function make(name, phoneNumber) {
  return {
          name: name,
          phoneNumber: phoneNumber
        };
}

var query = "fragment CommonTypes_Shift_OnsiteManager on Shift   {\nname: onsiteManagerName  \nphoneNumber: onsiteManagerPhoneNumber  \n}\n";

exports.Raw = Raw;
exports.query = query;
exports.parse = parse;
exports.serialize = serialize;
exports.verifyArgsAndParse = verifyArgsAndParse;
exports.verifyName = verifyName;
exports.tToR = tToR;
exports.make = make;
/* Relude_Option Not a pure module */
